
import React, { useEffect, useState } from 'react';
import ProfileCard from './components/ProfileCard';
import { CaregiverProfile } from '../../types/index';
import { caregiverService } from '../../services/caregiverService';
import CryptoJS from 'crypto-js';

const CaregiverProfilePage: React.FC = () => {
    const [profile, setProfile] = useState<CaregiverProfile | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [isExpired, setIsExpired] = useState<boolean>(false);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            try {
                const params = (new URL(document.location.href)).searchParams;
                let agentId = params.get("agentId");
                //let agentId= "U2FsdGVkX1/atlqb5IFUmvVSkqemcDLsRA+ggOQBKgw="
                
                if (!agentId) {
                    setError("No profile identifier found.");
                    setLoading(false);
                    return;
                }

                // Decrypt agentId
                try {
                    agentId = agentId.replace(/ /g, "+");
                    const decrypted = CryptoJS.AES.decrypt(agentId, "CareConcierge");
                    agentId = decrypted.toString(CryptoJS.enc.Utf8);
                    
                    if (!agentId) throw new Error("Decryption failed");
                } catch (e) {
                    console.error("Decryption error", e);
                    setError("Invalid profile link.");
                    setLoading(false);
                    return;
                }

                const profileData = await caregiverService.getProfile(agentId);
                setProfile(profileData);
                setError(null);
            } catch (err: any) {
                console.error(err);
                if (err.message === "TOKEN_EXPIRED") {
                    setIsExpired(true);
                } else {
                    setError('Failed to load profile. Please try again later.');
                }
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, []);

    if (loading) {
        return <div className="container text-center p-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>;
    }

    if (isExpired) {
        // Display Link Expired View
        return (
            <div className="container d-flex flex-column align-items-center justify-content-center my-5 py-5 text-center">
                <div className="bg-light rounded-circle p-4 mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="text-secondary" style={{width: '64px', height: '64px'}}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                    </svg>
                </div>
                <h2 className="h3 fw-bold text-dark">Link Expired</h2>
                <p className="text-muted mt-2 mb-4" style={{maxWidth: '400px'}}>
                    The profile link you are trying to access has expired or is no longer valid. Please request a new link.
                </p>
            </div>
        );
    }

    if (error) {
        return <div className="container my-5"><div className="alert alert-danger text-center">{error}</div></div>;
    }

    if (!profile) {
        return null;
    }

    return (
        <main className="flex-grow-1 container my-4 my-md-5">
          <ProfileCard profile={profile} />
        </main>
    );
};

export default CaregiverProfilePage;
